import { FormattedCustomFormulaItem } from 'src/utils';

export interface GroupedCustomFormulaItems {
  [key: string]: {
    id: string;
    list: FormattedCustomFormulaItem[];
  };
}

export const groupFormulaItems = (
  items: FormattedCustomFormulaItem[],
  availableWidth: number,
): GroupedCustomFormulaItems => {
  const groupedItems: GroupedCustomFormulaItems = {};

  let currentGroup = { id: '', list: [] as FormattedCustomFormulaItem[] };
  let currentLineWidth = 0;
  let groupIndex = 1;

  items.forEach((item) => {
    if (currentLineWidth + item.width <= availableWidth) {
      currentGroup.id = `group_${groupIndex}`;
      currentGroup.list.push(item);
      currentLineWidth += item.width;
    } else {
      groupedItems[currentGroup.id] = { ...currentGroup };
      currentGroup = { id: `group_${++groupIndex}`, list: [item] };
      currentLineWidth = item.width;
    }
  });

  if (currentGroup.list.length > 0) {
    groupedItems[currentGroup.id] = { ...currentGroup };
  }

  return groupedItems;
};

export const flattenGroupedFormulaItems = (
  groupedItems: GroupedCustomFormulaItems,
): FormattedCustomFormulaItem[] => {
  let flattenedItems: FormattedCustomFormulaItem[] = [];

  for (const key in groupedItems) {
    const group = groupedItems[key];
    const { list } = group;

    flattenedItems = [...flattenedItems, ...list];
  }

  return flattenedItems;
};
